import { AccordionCard } from '@ver-uds/react';
import React, { ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';
import type { AccessMethodFormData, AccessMethodType } from './AccessMethodFormData';

export type AccessMethodAccordionCardProps = {
  id: string;
  label: string;
  headerTag?: ReactNode;
  value: AccessMethodType;
  body: ReactNode;
  moreDetails: ReactNode;
};

const accessMethodRequiredError = 'You must choose an account access method.';

const AccessMethodAccordionCard = ({
  id,
  label,
  headerTag,
  value,
  body,
  moreDetails,
}: AccessMethodAccordionCardProps): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/unbound-method
  const { register } = useFormContext<AccessMethodFormData>();

  return (
    <AccordionCard controls={`accessMethod-${id}-details`}>
      <AccordionCard.RadioHeader
        id={`accessMethod-${id}`}
        name="accessMethod"
        className="grid-row grid-gap"
        label={label}
        value={value}
        aria-describedby={headerTag ? `accessMethod-${id}-header-tag` : undefined}
        ref={register({
          required: {
            value: true,
            message: accessMethodRequiredError,
          },
        })}
      >
        {headerTag ? (
          <div
            id={`accessMethod-${id}-header-tag`}
            className="grid-col-12 tablet:grid-col-auto grid-gap margin-top-1 tablet:margin-top-0"
          >
            {headerTag}
          </div>
        ) : null}
      </AccordionCard.RadioHeader>
      <AccordionCard.Body>{body}</AccordionCard.Body>
      <AccordionCard.MoreDetails id={`accessMethod-${id}-details`}>
        <div className="border-top border-base-lighter">{moreDetails}</div>
      </AccordionCard.MoreDetails>
    </AccordionCard>
  );
};

export default AccessMethodAccordionCard;
